import { render, staticRenderFns } from "./MenuCard.vue?vue&type=template&id=508d83e6&scoped=true&"
import script from "./MenuCard.vue?vue&type=script&lang=js&"
export * from "./MenuCard.vue?vue&type=script&lang=js&"
import style0 from "./MenuCard.vue?vue&type=style&index=0&id=508d83e6&prod&lang=scss&scoped=true&"
import style1 from "./MenuCard.vue?vue&type=style&index=1&id=508d83e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508d83e6",
  null
  
)

export default component.exports